import { BrandLogo as SharedBrandLogo } from '@cedrum/shared-web/brand/BrandLogo';

export default function BrandLogo({ variant = 'site', ariaLabel = 'cedrum', ...rest }) {
  return <SharedBrandLogo variant={variant} ariaLabel={ariaLabel} {...rest} />;
}
